// extracted by mini-css-extract-plugin
export default {"app-layout":"app-layout_app-layout__0iSTd","app-layout__body":"app-layout_app-layout__body__ohzOa","app-layout__content":"app-layout_app-layout__content__ecJMB"};